const set = require('regenerate')();

set.addRange(0x1720, 0x1736);
module.exports = set;